<div [innerHTML]="localBusinessJsonLd"></div>
<div [innerHTML]="webSiteJsonLd"></div>

@if (isMaintenanceInProgress) {
  <oops-page />
}

@if (!isMaintenanceInProgress) {
  <announcement />
  <router-outlet />
}

<cart-modal />
<noty />
<button-up />


<!-- showcase all icons -->
<!--@for (icon of AllMbiIcons; track icon) {-->
<!--  <i class="mbi {{ icon }}"></i>: {{ icon }}<br>-->
<!--}-->
